import { render } from "./MailInsertForm.vue?vue&type=template&id=5a043ea2"
import script from "./MailInsertForm.vue?vue&type=script&lang=js"
export * from "./MailInsertForm.vue?vue&type=script&lang=js"

import "./MailInsertForm.vue?vue&type=style&index=0&id=5a043ea2&lang=scss"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__